	//Chain as another products
// === КОНСТАНТИ ===
const SELECTORS = {
	CHAIN_WRAPPER: 'chain-as-product',
	CHAIN_LENGTH_OPTIONS: '.chain-products__length-option:not(.show-all)',
	CHAIN_TYPE_OPTIONS: '.chain-products__chain-metal-option:not(.chain-products__no-chain-option):not(.show-all)', 
	CHAIN_METAL_PRICE: '.chain-products__metal-price',
	METAL_MODAL_OPTIONS: '[data-chain-products-metals]',
	METAL_OPTIONS_LIST: '.custom-select--metal .custom-options-list',
	CUSTOM_OPTION_ACTIVE: '.custom-option.active',
	ADDITIONAL_INPUTS: {
		PRODUCT_ID: '.id-input-2',
		QUANTITY: '.quantity-input-2', 
		CHAIN_LENGTH: '.chain-length-input-2',
		METAL: '.metal-input-2'
	},
	VARIANT_RADIOS: 'variant-radios'
};

const CSS_CLASSES = {
	ACTIVE: 'active',
	HIDDEN: 'hidden',
	HIDDEN_CHAIN_OPTION: 'hidden-chain-option',
	ACTIVE_METAL: 'active-metal',
	FROM_SHOW_ALL: 'from-show-all',
	DISABLED: 'disabled',
	CUSTOM_OPTION: 'custom-option'
};

const ATTRIBUTES = {
	CHAIN_METAL_OPTION: 'data-chain-metal-option',
	CHAIN_METAL_VALUE: 'data-chain-metal-value', 
	CHAIN_LENGTH_OPTION: 'data-chain-length-option',
	CHAIN_LENGTH_VALUE: 'data-chain-length-value',
	METAL_HANDLE: 'data-metal-handle',
	METAL_VALUE: 'metal-value',
	NO_CHAIN: 'data-no-chain',
	ADD_CHAIN: 'data-add-chain',
	CURRENCY_SIGN: 'data-currency-sign'
};

const DEFAULTS = {
	METAL: 'Sterling Silver',
	METAL_HANDLE: 'white',
	COLOR: '#121212'
};

// Color constants
const COLORS = {
	ACTIVE_TITLE: "#121212",
};

// === BASE COMPONENT ===
class BaseChainComponent extends HTMLElement {
	constructor() {
		super();
	}

	// Get URL search parameters
	getUrlParams() {
		return new URL(document.location).searchParams;
	}

	// Set default color for multiple elements
	setDefaultColors(...elements) {
		elements.forEach(el => {
			if (el) el.style.color = DEFAULTS.COLOR;
		});
	}

	// Find active element in collection
	findActiveElement(elements, className = CSS_CLASSES.ACTIVE) {
		return Array.from(elements).find(el => el.classList.contains(className));
	}

	// Format price with currency sign
	formatPrice(price) {
		const currencySign = document.querySelector(`[${ATTRIBUTES.CURRENCY_SIGN}]`)?.dataset.currencySign;
		const formattedPrice = price / 100;
		return currencySign ? `${currencySign}${formattedPrice}` : formattedPrice;
	}

	// Set title color for chain elements
	setTitleColor() {
		if (this.chainTitle) this.chainTitle.style.color = COLORS.ACTIVE_TITLE;
		if (this.chainStyleTitle) this.chainStyleTitle.style.color = COLORS.ACTIVE_TITLE;
	}

	// Toggle CSS class on element
	toggleClass(element, className, condition) {
		if (element) {
			element.classList.toggle(className, condition);
		}
	}

	// Remove class from multiple elements
	removeClassFromElements(elements, className) {
		Array.from(elements).forEach(el => el.classList.remove(className));
	}

	// Add class to multiple elements
	addClassToElements(elements, className) {
		Array.from(elements).forEach(el => el.classList.add(className));
	}

	// Safe JSON parsing with error handling
	safeParseJSON(element, fallback = null) {
		if (!element || !element.textContent) {
			console.warn('Element or content not found for JSON parsing');
			return fallback;
		}
		
		try {
			return JSON.parse(element.textContent);
		} catch (error) {
			console.error('Failed to parse JSON:', error, element.textContent);
			return fallback;
		}
	}

	// Get chain variants data with error handling
	getChainVariantsData(chainId) {
		const chainVariantsElement = document.getElementById(`chainVariantsJson--${chainId}`);
		return this.safeParseJSON(chainVariantsElement, []);
	}

	// Safe Math.min with validation
	safeMinPrice(items) {
		if (!Array.isArray(items) || items.length === 0) {
			console.warn('Invalid array provided to safeMinPrice');
			return 0;
		}
		const validPrices = items.filter(item => item && typeof item.price === 'number').map(item => item.price);
		return validPrices.length > 0 ? Math.min(...validPrices) : 0;
	}

	// Unified URL update method
	updateURL() {
		if (this.variantsSelects) {
			this.variantsSelects.updateURL.call(this.variantsSelects);
		} else if (this.wrapper && this.wrapper.updateChainURL) {
			this.wrapper.updateChainURL.call(this.wrapper);
		}
	}

	// Disable/enable form inputs
	setInputsDisabled(inputs, disabled) {
		inputs.forEach(input => {
			if (input) {
				if (disabled) {
					input.setAttribute("disabled", "true");
				} else {
					input.removeAttribute("disabled");
				}
			}
		});
	}

	// Clean and format option strings

	// Format options array
	formatOptionsArray(options) {
		return options ? options.map(opt => this.cleanOptionString(opt)) : [];
	}



	// Get element attribute safely
	getElementAttribute(element, attribute, fallback = '') {
		return element ? (element.getAttribute(attribute) || fallback) : fallback;
	}

	// Set multiple form input values
	setFormInputValues(inputValuePairs) {
		inputValuePairs.forEach(({input, value}) => {
			if (input && value !== undefined) {
				input.value = value;
			}
		});
	}

	// Update only price without URL
	updatePriceOnly(delay = 0) {
		const updateFunction = () => {
			if (typeof window.setPriceAccordingPickedOptions === 'function') {
				window.setPriceAccordingPickedOptions();
			}
		};
		
		if (delay > 0) {
			setTimeout(updateFunction, delay);
		} else {
			updateFunction();
		}
	}

	// Unified price update with URL
	updatePriceAndURL(delay = 0) {
		const updateFunction = () => {
			this.updateURL();
			this.updatePriceOnly();
		};
		
		if (delay > 0) {
			setTimeout(updateFunction, delay);
		} else {
			updateFunction();
		}
	}

	// Toggle element visibility
	toggleElementVisibility(element, show, hiddenClass = CSS_CLASSES.HIDDEN) {
		if (element) {
			element.classList.toggle(hiddenClass, !show);
		}
	}
}

if (!customElements.get("chain-as-product")) {
		

		if (!customElements.get("chain-as-product-length")) {
			class ChainAsProductLength extends BaseChainComponent {
				constructor() {
					super();
					this.setVariables();
					this.setEvents();
				}

				setVariables() {
					this.wrapper = document.querySelector(SELECTORS.CHAIN_WRAPPER);
					this.chainLengthOptions = this.querySelectorAll(SELECTORS.CHAIN_LENGTH_OPTIONS);
					this.chainTypeOptions = this.wrapper.querySelectorAll(SELECTORS.CHAIN_TYPE_OPTIONS);

					this.metalModalOptions = this.wrapper.querySelectorAll(SELECTORS.METAL_MODAL_OPTIONS);
					this.chainProductSubtitle = this.wrapper.querySelector("[data-chain-product-subtitle]");
					this.chainLengthTitle = this.querySelector("[data-chain-length-title]");
					this.chainTypeTitle = this.wrapper.querySelector("[data-chain-type-title]");
					this.chainTitle = this.wrapper.querySelector(".chain-products__chain-title");
					this.firstMetalProductId = Array.from(this.chainTypeOptions)[0].dataset.chainMetalOption;
					this.additionalProductInputEl = document.querySelector(SELECTORS.ADDITIONAL_INPUTS.PRODUCT_ID);
					this.additionalProductInputQuantityEl = document.querySelector(SELECTORS.ADDITIONAL_INPUTS.QUANTITY);
					this.additionalChainLengthEl = document.querySelector(SELECTORS.ADDITIONAL_INPUTS.CHAIN_LENGTH);
					this.additionalMetalEl = document.querySelector(SELECTORS.ADDITIONAL_INPUTS.METAL);
					this.variantsSelects = document.querySelector(SELECTORS.VARIANT_RADIOS);
					
					this.noChainButton = this.wrapper.querySelector("[data-no-chain]");

					this.productJsonData = JSON.parse(document.querySelector("#productsJsonGlobal").innerHTML);
					
					// Check if product has no solid tag
					this.hasNoSolidTag = window.noSolidProductTag && this.productJsonData.tags.includes(window.noSolidProductTag);
				}

				setEvents() {
					this.chainTypeOptions.forEach((typeEl) =>
						typeEl.addEventListener("click", this.onTypeClick.bind(this)),
					);
					this.chainLengthOptions.forEach((lengthEl) =>
						lengthEl.addEventListener("click", this.onLengthClick.bind(this)),
					);
					this.metalModalOptions.forEach(metalEl=>metalEl.addEventListener("click", this.onMetalModalClick.bind(this)))
				}

				renderAdditionalLengthCosts(arr, currentChainId, currentChainValue) {
					const metalDataArr = this.getChainVariantsDataArr(currentChainId);
					const minMetalPrice = this.calculateMinMetalPrice(metalDataArr, currentChainValue);

					Array.from(arr).forEach((el) => {
						if (el.dataset.chainLengthOption !== currentChainId) return;
						this.updateLengthPriceDisplay(el, metalDataArr, currentChainValue, minMetalPrice);
					});
				}

				calculateMinMetalPrice(metalDataArr, currentChainValue) {
					const arrayToFilter = metalDataArr.filter((el) => el.options.includes(currentChainValue));
					return this.safeMinPrice(arrayToFilter);
				}

				updateLengthPriceDisplay(element, metalDataArr, currentChainValue, minMetalPrice) {
					const priceEl = element.querySelector(".chain-products__length-price");
					const chainLengthValue = element.dataset.chainLengthValue;
					
					const chainVariant = this.findVariantByOptions(metalDataArr, currentChainValue, chainLengthValue);
					if (!chainVariant) return;

					const priceDecrement = chainVariant.price - minMetalPrice;
					const priceString = this.formatPriceDifference(priceDecrement);
					priceEl.innerHTML = priceString;
				}

				findVariantByOptions(metalDataArr, currentChainValue, chainLengthValue) {
					return metalDataArr.find((variant) => {
						const formattedLengthValue = variant.options[1].replaceAll('"', "");
						const formattedOptionsArr = variant.options.map((el) => el.replaceAll('"', ""));
						
						return formattedOptionsArr.includes(currentChainValue) && 
							   formattedLengthValue === chainLengthValue;
					});
				}

				formatPriceDifference(priceDecrement) {
					if (!priceDecrement) return "";
					
					const currencySign = document.querySelector(`[${ATTRIBUTES.CURRENCY_SIGN}]`)?.dataset.currencySign || "";
					const formattedPrice = priceDecrement / 100;
					return `+${currencySign}${formattedPrice}`;
				}

				onTypeClick(event) {
					const typeEl = event.currentTarget;
					this.showLengthByType(typeEl);
				}

				showLengthByType(typeEl){
					const arrOptions = this.chainLengthOptions;
					const currentChainMetalId = typeEl.dataset.chainMetalOption;
					const currentChainMetalValue = typeEl.dataset.chainMetalValue;
					this.setTitleColorDefault()
					arrOptions.forEach((chainLengthEl) =>
						chainLengthEl.classList.remove(CSS_CLASSES.ACTIVE),
					);
					this.productToggleHandler(
						arrOptions,
						ATTRIBUTES.CHAIN_LENGTH_OPTION,
						currentChainMetalId,
					);
					this.renderAdditionalLengthCosts(arrOptions, currentChainMetalId, currentChainMetalValue);
					this.classList.remove(CSS_CLASSES.HIDDEN);
				}

				getActiveMetal(){
					const metalEl = this.findActiveElement(this.metalModalOptions, CSS_CLASSES.ACTIVE);
					return metalEl ? this.getElementAttribute(metalEl, ATTRIBUTES.METAL_VALUE) : null;
				}

				productToggleHandler(arr, dataset, currentChainMetalId) {
					if (currentChainMetalId) {
						this.firstMetalProductId = currentChainMetalId;
					}
					const chainLength = Array.from(arr).filter((el) => {
						const currentProductId = el.getAttribute(`${dataset}`);
						this.firstMetalProductId !== currentProductId
							? el.classList.add(CSS_CLASSES.HIDDEN_CHAIN_OPTION)
							: el.classList.remove(CSS_CLASSES.HIDDEN_CHAIN_OPTION);
							return this.firstMetalProductId == currentProductId
					});
					if(chainLength.length == 1){
						setTimeout(()=>{
							chainLength[0].click();
						})
					}
				}

				onLengthClick(event) {
					const currentLengthEl = event.currentTarget;
					const currentChainId = currentLengthEl.dataset.chainLengthOption;
					
					this.updateActiveLengthSelection(currentLengthEl);
					const activeMetalOptionEl = this.getActiveTypeEl(currentChainId);
					this.setTitleColorDefault();

					if (activeMetalOptionEl) {
						this.processChainVariantSelection(currentLengthEl, currentChainId, activeMetalOptionEl);
					}

					this.finalizeSelection();
				}

				updateActiveLengthSelection(currentLengthEl) {
					const activeLengthOption = this.findActiveElement(this.chainLengthOptions, CSS_CLASSES.ACTIVE);
					if (activeLengthOption) {
						activeLengthOption.classList.remove(CSS_CLASSES.ACTIVE);
					}
					currentLengthEl.classList.add(CSS_CLASSES.ACTIVE);
				}

				processChainVariantSelection(currentLengthEl, currentChainId, activeMetalOptionEl) {
					const activeMetalOptionValue = activeMetalOptionEl.getAttribute(ATTRIBUTES.CHAIN_METAL_VALUE);
					const activeLengthOptionValue = currentLengthEl.getAttribute(ATTRIBUTES.CHAIN_LENGTH_VALUE);
					
					const activeChainVariant = this.getChainVariantByMetalAndLength({
						currentChainId, 
						activeMetalOptionValue, 
						activeLengthOptionValue
					});

					if (activeChainVariant) {
						this.updateFormInputs(activeChainVariant);
						this.updateChainDisplay(activeChainVariant);
					}
				}

				updateFormInputs(activeChainVariant) {
					this.setFormInputValues([
						{input: this.additionalProductInputEl, value: activeChainVariant.id},
						{input: this.additionalChainLengthEl, value: activeChainVariant.option2},
						{input: this.additionalMetalEl, value: activeChainVariant.option1}
					]);
				}

				updateChainDisplay(activeChainVariant) {
					const chainLength = activeChainVariant.option2;
					const chainMetal = activeChainVariant.option1;
					const imageURL = activeChainVariant.featured_image?.src;

					this.setChainSubtitle(chainLength, chainMetal);
					this.setImageChainUrlProperty(imageURL);
					this.setChainLengthMainProductProperty(activeChainVariant.title);
				}

				finalizeSelection() {
					this.updatePriceAndURL();
				}

				setTitleColorDefault(){
					this.setDefaultColors(this.chainLengthTitle, this.chainTitle, this.chainTypeTitle);
				}

				getActiveTypeEl(currentChainId){
					let activeMetalOptionEl = this.findActiveElement(this.chainTypeOptions, CSS_CLASSES.ACTIVE);
					if(!activeMetalOptionEl){
						const activeMetal = this.getActiveMetal();
						
						const currentChainTypeEl = this.findChainTypeByMetalAndID(activeMetal, currentChainId)
						if(!currentChainTypeEl.classList.contains(CSS_CLASSES.ACTIVE)){
							currentChainTypeEl.classList.add(CSS_CLASSES.ACTIVE)
						}

						activeMetalOptionEl = currentChainTypeEl;
					}

					return activeMetalOptionEl;
				}

				getChainVariantByMetalAndLength({currentChainId, activeMetalOptionValue, activeLengthOptionValue}){
					const metalDataArr = this.getChainVariantsDataArr(currentChainId);
					return metalDataArr.find((el) => {
								const formattedLengthOptionValue = el.options[1].replaceAll('"', "");
								const formattedOptionsArr = el.options.map((el) => el.replaceAll('"', ""));
	
								if (
									formattedOptionsArr.includes(activeMetalOptionValue) &&
									formattedLengthOptionValue === activeLengthOptionValue
								) {
									return el;
								}
						});
				}

				setChainSubtitle(lengthValue, metal){
					const formatedMetal = metal.toLowerCase().includes("gold") && !this.hasNoSolidTag ? "Solid " + metal : metal;
					this.chainProductSubtitle.textContent = formatedMetal + " " + lengthValue + " Chain"
				}

				getChainVariantsDataArr(currentChainId) {
					return this.getChainVariantsData(currentChainId);
				}

				findLengthByTypeAndValue(chainId, length){
					return Array.from(this.chainLengthOptions).find(el=> el.getAttribute("data-chain-length-option") == chainId && el.getAttribute("data-chain-length-value") == length)
				}

				findChainTypeByMetalAndID(metal, chainId){
					return Array.from(this.chainTypeOptions).find(el=> el.getAttribute("data-chain-metal-value") == metal && el.getAttribute("data-chain-metal-option") == chainId)
				}


				onMetalModalClick(){
					this.classList.add("hidden");
					this.additionalChainLengthEl.value = "";
					Array.from(this.chainLengthOptions).map((el) =>
						el.classList.remove("active"),
					);
					this.updatePriceOnly();
				}

				setImageChainUrlProperty = (url) => {
					const formatedURL = url ? url.replace(/^\/\//, 'https://') : "";
					const inputImageUrlProperty =
						document.querySelector("input[name='items[1][properties[_image_url]]']");
					inputImageUrlProperty && (inputImageUrlProperty.value = formatedURL);
				};

				setChainLengthMainProductProperty(sku){
					const inputMainProduct = document.querySelector("input[name='items[0][properties[_Chain_Length]]']");
					inputMainProduct && (inputMainProduct.value = sku);
				}

			}
			customElements.define("chain-as-product-length", ChainAsProductLength);
		}

		if (!customElements.get("chain-as-product-types")) {
			class ChainAsProductTypes extends BaseChainComponent {
				constructor() {
					super();
					this.setVariables();
					this.setEvents();
					this.firstRender();
				}

				setVariables() {
					this.wrapper = document.querySelector(SELECTORS.CHAIN_WRAPPER);
					this.twoToneMetals = document.querySelector("two-color-metal") || window.twoToneOneSectionProduct;
					this.chainLengthComponent = this.wrapper.querySelector("chain-as-product-length");
					this.chainMetalOptions = this.querySelectorAll(SELECTORS.CHAIN_TYPE_OPTIONS);
					this.modalMetalEl = this.wrapper.querySelector("chain-as-product-metals");
					this.metalModalOptions = this.wrapper.querySelectorAll(SELECTORS.METAL_MODAL_OPTIONS);
					this.metalOptions = document.querySelector(SELECTORS.METAL_OPTIONS_LIST);
					this.chainTitle = this.wrapper.querySelector(".chain-products__chain-title");
					this.chainStyleTitle = this.querySelector("[data-chain-type-title]");
					this.additionalChainLengthEl = document.querySelector(SELECTORS.ADDITIONAL_INPUTS.CHAIN_LENGTH);
					this.additionalMetalEl = document.querySelector(SELECTORS.ADDITIONAL_INPUTS.METAL);
					this.additionalProductInputEl = document.querySelector(SELECTORS.ADDITIONAL_INPUTS.PRODUCT_ID);
					this.variantsSelects = document.querySelector(SELECTORS.VARIANT_RADIOS);
					this.noChainButton = this.wrapper.querySelector(`[${ATTRIBUTES.NO_CHAIN}]`);
					this.addChainButton = this.wrapper.querySelector(`[${ATTRIBUTES.ADD_CHAIN}]`);
					this.blockSubtitle = this.wrapper.querySelector("[data-chain-product-subtitle]");

					this.defaultMetal = DEFAULTS.METAL;
				}

				setEvents() {
					this.metalOptions?.addEventListener("click", this.onMetalOptionClick.bind(this));
					this.chainMetalOptions.forEach((el) =>
						el.addEventListener("click", this.chainTypeClick.bind(this)),
					);
					this.metalModalOptions.forEach(metalEl=>metalEl.addEventListener("click", this.modalActiveMetalChange.bind(this)));
					document.addEventListener("add-chain-button-click", this.onAddChainClick.bind(this));

				}

				onMetalOptionClick(event) {
					const activeMetalEl = event.target.closest(".custom-option");
					if (!activeMetalEl) return;
					const isNoChain = this.addChainButton.classList.contains("active");
					if(isNoChain){
						const activeMetalInput = activeMetalEl.querySelector("input");
						let value = activeMetalInput.value;
						if(this.twoToneMetals){
							const handle = activeMetalInput.getAttribute("data-metal-handle");
							const getToneMetal = this.modalMetalEl.getTwoToneMetal.call(this.modalMetalEl, handle);
							value = getToneMetal?.getAttribute("metal-value");
						}
						this.chainLengthComponent.classList.add("hidden");
						this.renderTypesByMetal(value);
					}
				}

				getActiveMetal() {
					const params = this.getUrlParams();
					let metal = params.get("metal");
					if (!metal) {
						if(this.metalOptions){
							if(this.twoToneMetals){
								const activeMetalInput = this.metalOptions.querySelector(`${SELECTORS.CUSTOM_OPTION_ACTIVE} input`);
								const handle = activeMetalInput.getAttribute("data-metal-handle");
								const getToneMetal = this.modalMetalEl.getTwoToneMetal.call(this.modalMetalEl, handle);
								metal = getToneMetal?.getAttribute("metal-value");
							}else{
								const activeMetal = this.metalOptions.querySelector(`${SELECTORS.CUSTOM_OPTION_ACTIVE} input`).value;
								metal = activeMetal
							}
						}else{
							metal = this.defaultMetal
						}
						

					} 
					return metal;
				}

				firstRender() {
					const params = new URL(document.location).searchParams;
					const length = params.get("length");
					let metal = params.get("metal");
					const chainId = params.get("chain-id");
					
					const noChainValue = params.get("no-chain");
					let typesByMetal = [];
					if (!noChainValue && metal) {
						this.setPrice();
						metal = this.getActiveMetal();
						
						typesByMetal = this.getTypesByMetal(metal);
						if(typesByMetal.length){
							let activeType;
							if(chainId){
								activeType = typesByMetal.find((type) => {
									const metalElId = type.getAttribute("data-chain-metal-option");
									return chainId === metalElId
								});
							}
							this.renderTypesByMetal(metal, activeType);
							if (chainId) {
								activeType?.click()
	
								if (length) {
									this.renderFirstLength(length, chainId)
								}
							} 
							this.classList.remove("hidden");
						}else{
							this.classList.add("hidden");
						}
					
					}else{
						this.classList.add("hidden");
					}
				}

				renderFirstLength(length, chainId){
					const lengthByTypes = this.chainLengthComponent.querySelectorAll(
						`.chain-products__length-option:not(.${CSS_CLASSES.HIDDEN_CHAIN_OPTION}):not(.show-all)`,
					);
					Array.from(lengthByTypes).forEach((lengthEl) => {
						const lengthElValue = lengthEl
							.getAttribute("data-chain-length-value")
							.replace("+", "")
							.replace(/ +/g, " ");
							const formattedLength = length.replace(/ +/g, ' ');
							const lengthElId = lengthEl.getAttribute('data-chain-length-option');
						if (lengthElValue === formattedLength && lengthElId === chainId) {
							lengthEl.click();
						}
					});
					this.chainLengthComponent.classList.remove(CSS_CLASSES.HIDDEN)
				}

				onAddChainClick(){
					const activeMetal = this.getActiveMetal();
					this.renderTypesByMetal(activeMetal);
					this.setPrice()
				}


				setPrice() {
					const chainTypes = this.chainMetalOptions
					Array.from(chainTypes).forEach((element) => {
						const chainMetalValue = element.dataset.chainMetalValue;
						const currentChainId = element.dataset.chainMetalOption;

						const priceEl = element.querySelector(SELECTORS.CHAIN_METAL_PRICE);
						let activeMetalValue = this.getActiveMetal();

							activeMetalValue !== chainMetalValue
							? element.classList.remove(CSS_CLASSES.ACTIVE_METAL)
							: element.classList.add(CSS_CLASSES.ACTIVE_METAL);
						
						
						const metalDataArr = this.getChainVariantsData(currentChainId);
						const arrayToFilter = metalDataArr.filter((el) => el.options.includes(chainMetalValue));
						const minMetalPrice = this.safeMinPrice(arrayToFilter);
						const currencySign =
							document.querySelector("[data-currency-sign]").dataset.currencySign;
						const formattedPrice = minMetalPrice / 100;
						const priceString = `+ ${currencySign}${formattedPrice}`;
						priceEl.innerHTML = priceString;
					});
				}

				getTypesByMetal(metal) {
					return Array.from(this.chainMetalOptions).filter((option) => {
						const metalElValue = option.getAttribute(ATTRIBUTES.CHAIN_METAL_VALUE);
						return metalElValue == metal;
					});
				}

				renderTypesByMetal(metal, activeType) {
					const typesElByMetal = this.getTypesByMetal(metal);
					const types = Array.from(this.chainMetalOptions).filter((el) => {
						el.classList.remove(CSS_CLASSES.ACTIVE);
						if (typesElByMetal.includes(el)) {
							el.classList.add(CSS_CLASSES.FROM_SHOW_ALL);
							return true;
						} else {
							el.classList.remove(CSS_CLASSES.FROM_SHOW_ALL);
							return false;
						}
					});
					if(types.length == 1 && !activeType){
						const chainType = types[0]
						this.setTitleColor();
						this.chainLengthComponent.showLengthByType.call(this.chainLengthComponent, chainType);
					}
				}

				chainTypeClick(event) {
					const chainType = event.currentTarget;
					this.setTitleColor();
					const activeMetalOption = this.findActiveElement(this.chainMetalOptions, CSS_CLASSES.ACTIVE);

					activeMetalOption && activeMetalOption.classList.remove(CSS_CLASSES.ACTIVE);

					chainType.classList.add(CSS_CLASSES.ACTIVE);
					this.updateURL();
					
					this.additionalChainLengthEl.value ="";
					this.updatePriceOnly();
					
					this.blockSubtitle.textContent = ""
				}

				modalActiveMetalChange(event){
					const activeMetalEl = event.currentTarget;
					const activeMetalValue = activeMetalEl.getAttribute(ATTRIBUTES.METAL_VALUE);
					this.renderTypesByMetal(activeMetalValue)

					this.setPrice();
					this.updateURL();
					this.additionalProductInputEl.value = "";
				}

			}
			customElements.define("chain-as-product-types", ChainAsProductTypes);
		}

		if (!customElements.get('chain-as-product-metals')) {
			class ChainAsProductMetals extends BaseChainComponent {
				constructor() {
					super();
					this.setVariables();
					this.setEvents();
					this.firstRender();
				}

				setVariables(){
					this.wrapper = document.querySelector(SELECTORS.CHAIN_WRAPPER);
					this.metalOptions = document.querySelector(SELECTORS.METAL_OPTIONS_LIST);

					this.twoToneMetals = document.querySelector("two-color-metal") || window.twoToneOneSectionProduct;
					this.twoToneOneSectionProduct = window.twoToneOneSectionProduct;

					this.modalMetals = this.querySelectorAll(SELECTORS.METAL_MODAL_OPTIONS);
					this.chainAsProductComponent = this.wrapper;
					this.chainTypes = this.wrapper.querySelector("chain-as-product-types");
					this.chainLengths = this.wrapper.querySelector("chain-as-product-length");
					this.noChainButton = this.wrapper.querySelector(`[${ATTRIBUTES.NO_CHAIN}]`);
					this.addChainButton = this.wrapper.querySelector(`[${ATTRIBUTES.ADD_CHAIN}]`);
					this.variantsSelects = document.querySelector(SELECTORS.VARIANT_RADIOS);
					this.blockSubtitle = this.wrapper.querySelector("[data-chain-product-subtitle]");

					this.defaultMetal = DEFAULTS.METAL;
					this.defaultMetalHandle = DEFAULTS.METAL_HANDLE;
				}

				setEvents(){
					this.metalOptions?.addEventListener("click", this.onMetalOptionClick.bind(this));
					this.modalMetals.forEach(metalEl=>metalEl.addEventListener("click", this.modalMetalClick.bind(this)));
					document.addEventListener("add-chain-button-click", this.addChainButtonClick.bind(this));
				}

				onMetalOptionClick(event){
					const activeMetalEl = event.target.closest(`.${CSS_CLASSES.CUSTOM_OPTION}`);

					if (!activeMetalEl) return;
					
					const isNoChain = this.addChainButton.classList.contains(CSS_CLASSES.ACTIVE);
					
					let activeMetalInput = activeMetalEl.querySelector("input");
					let activeMetalValue = activeMetalInput.value;
					let getToneMetal = "";

					if(this.twoToneMetals){
						getToneMetal = this.getTwoToneMetal(activeMetalInput.getAttribute(ATTRIBUTES.METAL_HANDLE));
						activeMetalValue = getToneMetal?.getAttribute(ATTRIBUTES.METAL_VALUE);
					}

					const typesByMetal = this.chainTypes.getTypesByMetal.call(this.chainTypes, activeMetalValue);

					const metals = this.getMetals({ input: this.twoToneMetals ? getToneMetal : activeMetalInput })
					metals.length ? this.removeAddButtonDisable() : this.setAddButtonDisable();

					if(isNoChain){
							this.renderMetals({ input: this.twoToneMetals ? getToneMetal : activeMetalInput, value: activeMetalValue });	
					}
					this.blockSubtitle.textContent = "";
					this.chainLengths.setImageChainUrlProperty.call(this.chainLengths, "");
					this.chainLengths.setChainLengthMainProductProperty.call(this.chainLengths, "");
					if(isNoChain && typesByMetal.length){
						this.chainTypes.classList.remove(CSS_CLASSES.HIDDEN);
					}
				}

				setAddButtonDisable(){
					this.addChainButton.classList.add(CSS_CLASSES.DISABLED);
					if(this.addChainButton.classList.contains(CSS_CLASSES.ACTIVE)){
						this.noChainButton.click();
					}
				}

				removeAddButtonDisable(){
					this.addChainButton.classList.remove(CSS_CLASSES.DISABLED);
				}

				getTwoToneMetal(handle){
					const caratsMetalActive = this.metalOptions.querySelector(SELECTORS.CUSTOM_OPTION_ACTIVE);
					const input = caratsMetalActive.querySelector("input");
					const valueCarats = input.value.split(" ")[0];
					if(valueCarats.includes("K")){
						const modalMetal = Array.from(this.modalMetals).find(metal=>{
							const metalHandle = metal.getAttribute(ATTRIBUTES.METAL_HANDLE);
							const metalValue = metal.getAttribute(ATTRIBUTES.METAL_VALUE);
							if(metalHandle == handle && metalValue?.includes(valueCarats)){
								return metal;
							}
						})
						return modalMetal;
					}
				}

				modalMetalClick(event){
					const currentElement = event.currentTarget;
					this.modalMetals.forEach(metalEl=>{
						metalEl.classList.toggle(CSS_CLASSES.ACTIVE, metalEl == currentElement)
					});
					this.updateURL();
					
					this.chainLengths.setImageChainUrlProperty.call(this.chainLengths, "");
					this.chainLengths.setChainLengthMainProductProperty.call(this.chainLengths, "");
					this.blockSubtitle.textContent = "";
					this.chainTypes.classList.remove(CSS_CLASSES.HIDDEN);
				}

				renderMetals({input, value}){
					let metalHandle =  ""
					let metalValue = value
					if(input){
						metalHandle = input.getAttribute(ATTRIBUTES.METAL_HANDLE);
						if(!metalValue){
							metalValue = this.twoToneMetals ? input.getAttribute(ATTRIBUTES.METAL_VALUE) : input.value;
						}
					}else{
						metalHandle = "all";
					}

					
					let equalMetal = false;
				
					const metals = Array.from(this.modalMetals).filter(metal=>{
						const handle = metal.getAttribute(ATTRIBUTES.METAL_HANDLE);
						const currentMetalValue = metal.getAttribute(ATTRIBUTES.METAL_VALUE);
						const typesByMetal = this.chainTypes.getTypesByMetal.call(this.chainTypes, currentMetalValue);
						if((handle == metalHandle || metalHandle == "all") && typesByMetal.length){
							metal.classList.remove(CSS_CLASSES.HIDDEN);
							metal.classList.toggle(CSS_CLASSES.ACTIVE, currentMetalValue == metalValue);
							if(currentMetalValue == metalValue){
								equalMetal = true; 
							}
							return true;
						}
            else{
							metal.classList.add(CSS_CLASSES.HIDDEN);
							metal.classList.remove(CSS_CLASSES.ACTIVE)
							return false;
						}
					})
				
					this.chainTypes.classList.toggle(CSS_CLASSES.HIDDEN, !equalMetal);
					if(!equalMetal && metals.length == 1){
						metals[0].click();
					}
				
				}

				getMetals({input}){
					let metalHandle;
					if(input){
						metalHandle = input.getAttribute(ATTRIBUTES.METAL_HANDLE);
					}else{
						metalHandle = "all";
					}

					
					return Array.from(this.modalMetals).filter(metal=>{
						const handle = metal.getAttribute(ATTRIBUTES.METAL_HANDLE);
						const metalValue = metal.getAttribute(ATTRIBUTES.METAL_VALUE);
						const typesByMetal = this.chainTypes.getTypesByMetal.call(this.chainTypes, metalValue);
						return (handle == metalHandle || metalHandle == "all") && typesByMetal.length;
					})
				}

				firstRender(){
					const params = this.getUrlParams();
					const noChainValue = params.get("no-chain");
					let metal = params.get("metal");
					
					if(!noChainValue && metal){
						let metalEl = this.metalOptions?.querySelector(`${SELECTORS.CUSTOM_OPTION_ACTIVE} input`);
						let metals ;
						if(metalEl){
							let metalParamsEl = ""
							if(metal){
								if(this.twoToneMetals){
									metalParamsEl = Array.from(this.modalMetals).find(metalEl=>{
										return metalEl.getAttribute(ATTRIBUTES.METAL_VALUE) == metal;
									})
								}else{
									metalParamsEl = Array.from(this.metalOptions.querySelectorAll(`.${CSS_CLASSES.CUSTOM_OPTION}`)).find(option=>{
										const input = option.querySelector("input");
										return input.value == metal
									})?.querySelector("input");

								}
							}
						
							if(metalParamsEl || this.twoToneMetals){
								metals = this.getMetals({input: metalParamsEl})
								this.renderMetals({input: metalParamsEl, value: metal})
							}
							else{
								metals = this.getMetals({ input: metalEl })
								this.renderMetals({ input: metalEl, value: metal })
							}
						}else{
							metals = this.getMetals({})
							this.renderMetals({value: metal})
						}
						

						metals.length ? this.removeAddButtonDisable() : this.setAddButtonDisable();
						this.classList.toggle("hidden", !metals.length)	
						
											
					}else{
						let metalEl = this.metalOptions?.querySelector(".custom-option.active input");

						if(this.twoToneMetals){
							const handle = metalEl.getAttribute("data-metal-handle");
							const getToneMetal = this.getTwoToneMetal(handle);
							metalEl = getToneMetal;
						}
						const metals = this.getMetals({input: metalEl});
						this.addChainButton.classList.toggle("disabled", !metals.length)
					}
				}

				addChainButtonClick(){
					let metalEl = this.metalOptions?.querySelector(".custom-option.active input");
					if(this.twoToneMetals){
						const handle = metalEl.getAttribute("data-metal-handle");
						metalEl = this.getTwoToneMetal(handle);
					}
					const value = metalEl ? metalEl.value : this.defaultMetal;
					const metals = this.getMetals({input: metalEl})
					if(metals.length){
						this.classList.remove("hidden");
						this.chainTypes.classList.remove("hidden");
						this.removeAddButtonDisable()
						this.renderMetals({input: metalEl, value: value});
						this.updateURL();

					}else{
						this.setAddButtonDisable()
					}
					
				}

			}
			customElements.define('chain-as-product-metals', ChainAsProductMetals);
		}

		class ChainAsProduct extends BaseChainComponent {
			constructor() {
				super();
				this.setVariables();
				this.setEvents();
				this.firstRender();
			}

			setVariables() {
				this.addChainButton = this.querySelector("[data-add-chain]");
				this.noChainButton = this.querySelector("[data-no-chain]");
				this.metalOptions = document.querySelector(SELECTORS.METAL_OPTIONS_LIST);
				this.modalMetals = this.querySelectorAll(SELECTORS.METAL_MODAL_OPTIONS);
				this.abbrValues = {
					X: 'yellow-white',
					U: 'white-yellow',
					Z: 'rose-white',
					V: 'white-rose',
					Y: 'yellow',
					W: 'white',
					R: 'rose',
				};


				this.additionalProductInputEl = document.querySelector(SELECTORS.ADDITIONAL_INPUTS.PRODUCT_ID);
				this.additionalProductInputQuantityEl = document.querySelector(SELECTORS.ADDITIONAL_INPUTS.QUANTITY);
				this.additionalChainLengthEl = document.querySelector(SELECTORS.ADDITIONAL_INPUTS.CHAIN_LENGTH);
				this.additionalMetalEl = document.querySelector(SELECTORS.ADDITIONAL_INPUTS.METAL);
				this.chainImageURl = document.querySelector("input[name='items[1][properties[_image_url]]']");
				this.chainMainProductProperty = document.querySelector("input[name='items[1][properties[_Main_Product]]']");
				this.mainProductChainProperty = document.querySelector("input[name='items[0][properties[_Chain_Length]]']")
				this.chainTypes = this.querySelector("chain-as-product-types");
				this.chainLength = this.querySelector("chain-as-product-length");
				this.chainTitle = this.querySelector(".chain-products__chain-title");
				this.lengthTitle = this.querySelector("[data-chain-length-title]");
				this.variantsSelects = document.querySelector(SELECTORS.VARIANT_RADIOS);
				this.chainProductSubtitle = this.querySelector("[data-chain-product-subtitle]");
				this.metalsEl = this.querySelector("chain-as-product-metals")
			}

			setEvents() {
				this.metalOptions?.addEventListener("click", this.onMetalOptionClick.bind(this));
				if(!this.metalOptions){
					this.modalMetals.forEach(metalEl=>metalEl.addEventListener("click", this.onMetalModalClick.bind(this)))
				}
				this.addChainButton.addEventListener("click", this.onOpenChains.bind(this));
				this.noChainButton.addEventListener("click", this.setNoChain.bind(this));
			}

			setNoChain() {
				this.addChainButton.classList.remove("active");
				this.noChainButton.classList.add("active");
				this.chainTypes.classList.add("hidden");
				this.chainLength.classList.add("hidden");
				this.additionalProductInputEl.value = "";
				this.setInputsDisabled([
					this.additionalProductInputEl,
					this.additionalProductInputQuantityEl,
					this.additionalChainLengthEl,
					this.additionalMetalEl,
					this.chainImageURl,
					this.chainMainProductProperty,
					this.mainProductChainProperty
				], true);
				this.setDefaultColors(this.chainTitle, this.lengthTitle);
				this.updateURL();
				this.chainProductSubtitle.textContent="";
				this.metalsEl.classList.add("hidden");
				this.updatePriceOnly();
			}

			onOpenChains() {
				if(this.addChainButton.classList.contains("active")) return;
				this.addChainButton.classList.add("active");
				this.noChainButton.classList.remove("active");
				this.chainTypes.classList.remove("hidden");
				this.setInputsDisabled([
					this.additionalProductInputEl,
					this.additionalProductInputQuantityEl,
					this.additionalChainLengthEl,
					this.additionalMetalEl,
					this.chainImageURl,
					this.chainMainProductProperty,
					this.mainProductChainProperty
				], false);
				this.setDefaultColors(this.chainTitle, this.lengthTitle);
				this.chainTypes.onAddChainClick.call(this.chainTypes);
				this.metalsEl.classList.remove("hidden");

				const addChainEvent = new CustomEvent("add-chain-button-click");
				document.dispatchEvent(addChainEvent)
			}

			getChainVariantId() {
				const chainMetalOptionEls = document.querySelectorAll('[data-chain-metal-value]:not(.show-all)');
				const chainAsOption = document.querySelector("chain-as-option");
				
				if (chainMetalOptionEls.length) {
					return this.buildChainProductParams(chainMetalOptionEls);
				} else if (chainAsOption) {
					return this.buildChainAsOptionParams();
				}
				
				return "";
			}

			buildChainProductParams(chainMetalOptionEls) {
				const noChainBtn = document.querySelector('.chain-products__no-chain-option.active');
				if (noChainBtn) return '&no-chain=true';

				const activeValues = this.getActiveChainValues(chainMetalOptionEls);
				const { lengthValue, metalValue, chainId } = activeValues;

				return lengthValue + metalValue + chainId;
			}

			getActiveChainValues(chainMetalOptionEls) {
				const chainLengthOptionEls = document.querySelectorAll('[data-chain-length-value]:not(.show-all)');
				const chainMetalElements = document.querySelectorAll("[data-chain-products-metals]");

				const activeChainMetalOption = this.findActiveElement(chainMetalOptionEls, CSS_CLASSES.ACTIVE)
					?.getAttribute('data-chain-metal-value');
				const activeMetal = this.findActiveElement(chainMetalElements, CSS_CLASSES.ACTIVE)
					?.getAttribute('metal-value');
				const activeChainLengthOption = this.findActiveElement(chainLengthOptionEls, CSS_CLASSES.ACTIVE)
					?.getAttribute('data-chain-length-value');

				const lengthValue = activeChainLengthOption ? `&length=${activeChainLengthOption}` : '';
				const metalValue = activeMetal ? `&metal=${activeMetal}` : 
					(activeChainMetalOption ? `&metal=${activeChainMetalOption}` : '');
				const chainId = this.determineChainId(chainMetalOptionEls, chainLengthOptionEls, activeChainMetalOption, activeChainLengthOption);

				return { lengthValue, metalValue, chainId };
			}

			determineChainId(metalEls, lengthEls, activeMetalOption, activeLengthOption) {
				if (activeMetalOption) {
					const activeChainMetalId = this.findActiveElement(metalEls, CSS_CLASSES.ACTIVE)
						?.getAttribute('data-chain-metal-option');
					return `&chain-id=${activeChainMetalId}`;
				}
				
				if (activeLengthOption) {
					const activeChainLengthId = this.findActiveElement(lengthEls, CSS_CLASSES.ACTIVE)
						?.getAttribute('data-chain-length-option');
					return `&chain-id=${activeChainLengthId}`;
				}

				return '';
			}

			buildChainAsOptionParams() {
				const chainAsOptionEl = document.querySelector("chain-as-option");
				let params = "";

				const chainTypeEl = chainAsOptionEl.querySelector("[data-chain-option-type].active");
				if (chainTypeEl) {
					params += "&chain-type=" + chainTypeEl.getAttribute("data-option-type");
				}

				const chainLengthEl = chainAsOptionEl.querySelector("[data-chain-length-option].active");
				if (chainLengthEl) {
					params += "&length=" + chainLengthEl.getAttribute("data-chain-length-option");
				}

				return params;
			}

			updateChainURL(){
					window.history.replaceState(
					{},
					'',
					`${
						this.dataset.url
					}?${this.getChainVariantId()}`,
				);
			}

			firstRender() {
				const params = this.getUrlParams();
				const noChainValue = params.get("no-chain");
				const metal = params.get("metal");
				let activeMetalEl = this.metalOptions?.querySelector(SELECTORS.CUSTOM_OPTION_ACTIVE);

				if(noChainValue){
					this.noChainButton.click();
					this.noChainButton.classList.toggle("active", true);
					this.addChainButton.classList.toggle("active", false);
				}else if(metal){
					this.noChainButton.classList.toggle("active", false);
					this.addChainButton.classList.toggle("active", true);
				}else{
					this.addChainButton.click()
				}

				if(!this.metalOptions && metal){
					activeMetalEl = Array.from(this.modalMetals).find(metalEl=>metalEl.getAttribute("metal-value") == metal);
					this.changeImage(activeMetalEl);
				}else{
					activeMetalEl && this.metalOptionChange(activeMetalEl);
				}

			}

			onMetalOptionClick(event){
				const activeMetalEl = event.target.closest(".custom-option");
				if (!activeMetalEl) return;
				this.metalOptionChange(activeMetalEl);
			}

			metalOptionChange(activeMetalEl){
				const activeMetalInput = activeMetalEl.querySelector("input");
				this.changeImage(activeMetalInput);
			}

			onMetalModalClick(event){
				const activeMetalEl = event.target.closest("[data-chain-products-metals]");
				if (!activeMetalEl) return;
				this.changeImage(activeMetalEl);
			}

			changeImage(activeMetalInput){
				const abbreviation = activeMetalInput.getAttribute("data-metal-abbreviation");
				const imageMetalValue = this.abbrValues[abbreviation];
				const imageEl = this.addChainButton.querySelector("img");
				const newUrl = imageEl.getAttribute(`data-src-${imageMetalValue}`);
				imageEl.src = newUrl;
			}
		}
		customElements.define("chain-as-product", ChainAsProduct);
}